import { NonIdealState } from "@blueprintjs/core";
import React, { Fragment } from "react";

import { Button } from "../../../../components";
import Checkbox from "../../../../components/CheckBox/Checkbox";
import { usePlaybookContext } from "../../playbook-context";
import styles from "./playbook-print-settings-menu.module.scss";

export const PlaybookPrintSettingsMenu = () => {
  const { setEditingPrintSettings, printSettingsOptions, printSettings, setPrintSettings } = usePlaybookContext();

  const getPrintSettingForKey = (key: string) => {
    const setting = printSettings.find((setting) => setting.name === key);
    return setting ? setting.value : "";
  };

  return (
    // Menu of print options for this playbook using the PrintSettingOptions object.
    <div className={styles.printSettingsMenu}>
      <div className={styles.printSettingsHeader}>
        <h3>Print and Format Settings</h3>
      </div>
      <div className={styles.optionsContainer}>
        {printSettingsOptions ? (
          Object.entries(printSettingsOptions).map(([optionGroupName, value]) => (
            <div key={optionGroupName} className={styles.optionGroup}>
              <div className={styles.optionGroupTitle}>{optionGroupName}</div>

              {value.map((option) => (
                <div key={option.key} className={styles.optionItem}>
                  {option.options.length === 2 && option.options.includes("true") ? (
                    // For two options,  true and false,  render a checkbox
                    <Fragment>
                      <label htmlFor={option.key} style={{ cursor: "pointer" }}>
                        <Checkbox
                          id={option.key}
                          checked={getPrintSettingForKey(option.key) === "true"}
                          large={true}
                          onClick={() => {
                            const checked = getPrintSettingForKey(option.key) === "true";
                            let newSettings = [...printSettings];
                            if (newSettings.find((setting) => setting.name === option.key)) {
                              // Update existing setting
                              newSettings = newSettings.map((setting) =>
                                setting.name === option.key
                                  ? { ...setting, value: checked ? "false" : "true" }
                                  : setting
                              );
                            } else {
                              // Add new setting
                              newSettings.push({ name: option.key, value: checked ? "false" : "true" });
                            }

                            // Update the print settings in context.
                            setPrintSettings(newSettings);
                          }}
                        />
                        {option.label}
                      </label>
                    </Fragment>
                  ) : (
                    // For other types of options,  render a select menu with the options.
                    <Fragment>
                      <div
                        style={{
                          minWidth: 300,
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <label htmlFor={option.key}>{option.label}:</label>
                        <select
                          id={option.key}
                          value={getPrintSettingForKey(option.key)}
                          style={{ minWidth: 100, padding: 2 }}
                          onChange={(e) => {
                            // Update or add the print setting.
                            let newSettings = [...printSettings];
                            if (newSettings.find((setting) => setting.name === option.key)) {
                              // Update existing setting
                              newSettings = newSettings.map((setting) =>
                                setting.name === option.key ? { ...setting, value: e.target.value } : setting
                              );
                            } else {
                              // Add new setting
                              newSettings.push({ name: option.key, value: e.target.value });
                            }

                            // If the value is empty, remove the setting.
                            if (e.target.value === "") {
                              newSettings = newSettings.filter((setting) => setting.name !== option.key);
                            }

                            // Update the print settings in context.
                            setPrintSettings(newSettings);
                          }}
                        >
                          {option.options.map((printSettingOption) => (
                            <option key={printSettingOption} value={printSettingOption}>
                              {printSettingOption}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Fragment>
                  )}
                </div>
              ))}
            </div>
          ))
        ) : (
          <NonIdealState title="Loading print settings options..." />
        )}
      </div>
      <Button
        className={styles.doneButton}
        onClick={() => {
          setEditingPrintSettings(false);
        }}
      >
        DONE
      </Button>
    </div>
  );
};
